import React from 'react';

const Check = ({fill}: {
  fill?: string;
}) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.34147 13.7454L3.84147 10.2454L2.6748 11.4121L7.34147 16.0788L17.3415 6.07878L16.1748 4.91211L7.34147 13.7454Z"
      fill={fill ? fill : "#669944"}
    />
  </svg>
);

export default Check;
